
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Epingler',
	'find_label': 'Rechercher',
	'findCancelLabel': 'Annuler',
	'dataPaneLabel': 'Données',
	'sourcePaneLabel': 'Sources sélectionnées',
	'sourcePaneContentLabel': 'Sélectionner une source',
	'emptySourcePaneTitle': 'Sélectionner une source',
	'emptySourcePaneCaption': 'Cliquez sur Sélectionner une source pour ajouter des données à utiliser pour créer un tableau de bord.',
	'addDataSource': 'Sélectionner une source',
	'addDataDashboardCoachMarkContents': 'Faites glisser des données du panneau des données jusqu\'à votre tableau de bord.',
	'addDataStoryCoachMarkContents': 'Faites glisser des données du panneau des données jusqu\'à votre histoire.',
	'addDataCoachMarkTitle': 'Ajouter des données',
	'selectSourcesText': 'Sélectionnez et ajoutez une source de données pour créer votre %{app}.',
	'selectSourcesLabel': 'Sélectionner une source',
	'errorSourcesTitle': 'Echec du chargement de l\'arborescence de données',
	'errorLoadingDataSources': 'Une erreur est survenue lors du chargement de la liste des ensembles de données',
	'errorLoadingDataTree': 'Une erreur est survenue lors du chargement de l\'arborescence',
	'dataSetPaneLastUpdated': 'Dernière mise à jour : %{date}',
	'dataSourcePaneDateUnknown': 'Inconnu',
	'moreTitle': 'Plus',
	'backLabel': 'Revenir en arrière',
	'addDataSourceDialogTitle': 'Sélectionner une source',
	'addDataSourceDialogButtonLabel': 'Ajouter',
	'dlg_use': 'Utiliser',
	'dlg_RelinkDataSourceTitle': 'Remplacer l\'ensemble de données "%{dataSourceName}" par ...',
	'propertiesDialogTitle': 'Propriétés',
	'loadingMetadata': 'Chargement des métadonnées',
	'missingDataSetData': 'Les données de cet ensemble de données ne sont pas disponibles. Actualisez l\'ensemble de données ou prenez contact avec votre administrateur pour accéder à la source.',
	'errorLoadingSource': 'Echec de chargement des métadonnées pour "%{sourceName}". Prenez contact avec votre administrateur pour des détails.',
	'errorMessageTitle': 'Erreur',
	'calculation_navigation_in_use': 'La suppression de calculs, de filtres ou de chemins de navigation invalide toutes les visualisations faisant référence à l\'élément supprimé. Confirmez-vous la suppression ?',
	'delete_confirm': 'Confirmer la suppression',
	'previewUnavailable': 'Le plateau de données et les filtres globaux ne sont pas disponibles pour ce type de pack.',
	'contextualGridTabName': 'Données de visualisation',
	'DATA_TRAY_no_data_text': 'Vous n\'avez pas de données actuellement',
	'contextualGridMenuLabel': 'Menu des données de visualisation',
	'contextualGridExport': 'Exporter',
	'nullValueText': 'Null',
	'forecastDetailsTabName': 'Détails statistiques de la prévision',
	'forecastDetailsModelLabel': 'Modèle',
	'forecastDetailsQualityMetricLabel': 'Mesures de précision',
	'forecastDetailsSmoothingCoefLabel': 'Paramètres',
	'forecastDetailsDiagnostics': 'Diagnostics',
	'forecastDetailsForecastLabel': 'Prévision',
	'forecastDetailsStatusLabel': 'Statut',
	'forecastDetailsAccuracyPercentLabel': 'Précision %',
	'forecastDetailsTrendLabel': 'Tendance',
	'forecastDetailsSeasonLabel': 'Saisonnalité',
	'forecastDetailsSeasonalPeriodLabel': 'Période saisonnière',
	'forecastDetailsAlphaLabel': 'Alpha',
	'forecastDetailsBetaLabel': 'Bêta',
	'forecastDetailsGammaLabel': 'Gamma',
	'forecastDetailsPhiLabel': 'Phi',
	'forecastDetailsMissingCount': 'Nombre manquant',
	'forecastDetailsSeriesLengthLabel': 'Longueur de série',
	'forecastDetailsIgnoredPeriods': 'Périodes ignorées',
	'forecastDetailsTrendStrength': 'Niveau de tendance',
	'forecastDetailsSeasonalityStrength': 'Niveau de saisonnalité',
	'forecastDetailsTimeDeltaUnit': 'Intervalle de date/heure',
	'forecastDetailsNotes': 'Remarques'
});
